export const petcoSurveyor = {
  "PETROTECHNICAL INSPECTION (M) SDN BHD": "melaka@sgs.com",
  "ITS TESTING SERVICES (M) SDN BHD": "itsmlk@intertek.com",
  "AMSPEC INSPECTION MALAYSIA SDN BHD": "melaka.operations@amspecgroup.com",
  "CCIC P&O MALAYSIA SDN BHD": "pom@ccicsg.com",
  "INSPECTORATE (M) SDN BHD": "malacca@inspectorate.com.my",
  "SAYBOLT (M) SDN BHD": "saybolt.malaysia@corelab.com",
  "SCHUTTERS FAR EAST SDN BHD": "schutter.mlkops@schutterfareast.com.my",
  "KVDT": "msaid.mokhty@petronas.com.my",
  "KLIA": "klia_intoplane@petronas.com.my",
};

export const SURVEYOR_EMAIL_COMPANY = {
  "melaka@sgs.com": "PETROTECHNICAL INSPECTION (M) SDN BHD",
  "itsmlk@intertek.com": "ITS TESTING SERVICES (M) SDN BHD",
  "melaka.operations@amspecgroup.com": "AMSPEC INSPECTION MALAYSIA SDN BHD",
  "pom@ccicsg.com": "CCIC P&O MALAYSIA SDN BHD",
  "malacca@inspectorate.com.my": "INSPECTORATE (M) SDN BHD",
  "saybolt.malaysia@corelab.com": "SAYBOLT (M) SDN BHD",
  "schutter.mlkops@schutterfareast.com.my": "SCHUTTERS FAR EAST SDN BHD",
  "msaid.mokhty@petronas.com.my": "KVDT",
  "irwan_mohamad@petronas.com.my": "KLIA",
  "klia_intoplane@petronas.com.my":  "KLIA",
  "anagha.k@petronas.com": "VOPS TEST"
};

export const SURVEYOR_EMAIL_COMPANY_MAP = {
  "@sgs.com": "PETROTECHNICAL INSPECTION (M) SDN BHD",
  "@intertek.com": "ITS TESTING SERVICES (M) SDN BHD",
  "@amspecgroup.com": "AMSPEC INSPECTION MALAYSIA SDN BHD",
  "@ccicsg.com": "CCIC P&O MALAYSIA SDN BHD",
  "@inspectorate.com.my": "INSPECTORATE (M) SDN BHD",
  "@bureauveritas.com": "INSPECTORATE (M) SDN BHD",
  "@corelab.com": "SAYBOLT (M) SDN BHD",
  "@saybolt.com.my":"SAYBOLT (M) SDN BHD",
  "@schutterfareast.com.my": "SCHUTTERS FAR EAST SDN BHD",
  "@petronas.com": "PETCO",
};

export const GROUP_OPU = {
  admin: "PDB",
  hq: "PDB",
  "": "PDB",
  pdb_agent: "PDB",
  petco_admin: "PETCO",
  petco_surveyor: "SURVEYOR",
  pli_admin: "PLI",
  pcg_admin: "PCG",
};

export const REGISTER_ERROR_CODE = {
  ACCOUNT_EXIST: "UsernameExistsException",
  INVALID_PASSWORD: "InvalidPasswordException",
};

export const OPU_UNIT = {
  PDB: "BBLS",
  PETCO: "BBLS",
  PLI: "MT",
  PCG: "MT",
};

const SUBMISSION_STATUS = {
  "Created": "grayAdminStatusBadge",
  "In Progress": "yellowAdminStatusBadge",
  "Submitted": "greenAdminStatusBadge",
  "Completed": "blueAdminStatusBadge"
}

export const getSubmissionStatusClass = (submissionStatus) => {
  return SUBMISSION_STATUS[submissionStatus]
}



// WEBPACK FOOTER //
// ./src/config/constant.js